<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('company-type')"
      prop="title"
      :rules="getValidationRule('required,minLength')"
      class="material-style">
      <el-input
        ref="firstField"
        :value="form.title"
        @input="form.title = valueTrimLeft($event)"
        @change="updateModelItem('title', { required: true })"/>
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormCompanyTypes',
  mixins: [Form]
}
</script>
